import React, { useCallback, useMemo, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
// eslint-disable-next-line import/no-cycle
import CostingStageMaster from './CostingStageMaster';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';

export const Context = React.createContext();
function ContextWrapper({ OpenReArrangeFunction, state, setState }) {
  const {
    SystemMastersDetails: { selectCostingStageList },
    Users: { logInRights },
  } = useSelector((reducer) => reducer);
  const { CheckActionPermission } = useComponent();
  const MasterAddEditAccess = CheckActionPermission(logInRights, 'masters', 'coastingStage', 'addEdit');
  const MasterDeleteAccess = CheckActionPermission(logInRights, 'masters', 'coastingStage', 'delete');
  const [cards, setCards] = useState([]);
  const [formState, setFormState] = useState({
    values: {},
    errors: {},
    isSubmitted: false,
    disableBtn: false,
    isLoading: false,
  });

  const validateInput = useCallback(
    (moduleName, id) => {
      if (moduleName.length === 0) {
        setFormState((prev) => ({ ...prev, errors: { ...prev.errors, [id]: 'Costing Stage is required.' } }));
        return;
      }
      const doesExist = cards.find((obj) => obj.name === moduleName && obj._id !== id);
      if (doesExist) {
        setFormState((prev) => ({ ...prev, errors: { ...prev.errors, [id]: 'This entry already exists.' } }));
      } else {
        setFormState((prev) => {
          return { ...prev, errors: {} };
        });
      }
    },
    [cards],
  );

  const updateSubmitState = useCallback((val) => {
    setFormState((prev) => ({ ...prev, isSubmitted: val }));
  }, []);

  const setFormValues = useCallback(
    (val, id) => {
      setFormState((prev) => ({ ...prev, values: { ...prev.values, [id]: val } }));
      validateInput(val, id);
    },
    [validateInput],
  );

  useEffect(() => {
    setCards(selectCostingStageList);
    if (state?.rearrangeModal === 'coastingStage') {
      setState((prev) => ({
        ...prev,
        rearrangeData: [...selectCostingStageList],
      }));
    }
  }, [selectCostingStageList, state?.rearrangeModal]);

  const updateArray = useCallback((val, _id) => {
    if (_id) {
      setCards((prev) => prev.map((obj) => (obj._id === _id ? { ...obj, ...val } : obj)));
      return null;
    }
    setCards((prev) => [...prev, { _id, ...val }]);
  }, []);

  const addNewItem = useCallback(() => {
    setCards((prev) => [...prev, { _id: `_id${prev.length}`, name: '' }]);
  }, []);

  const removeFromArray = useCallback((_id) => {
    setCards((prev) => prev.filter((obj) => obj._id !== _id));
  }, []);

  const value = useMemo(
    () => ({
      cards,
      updateArray,
      addNewItem,
      removeFromArray,
      updateSubmitState,
      formState,
      setFormValues,
      OpenReArrangeFunction,
      MasterAddEditAccess,
      MasterDeleteAccess,
    }),
    [
      cards,
      updateArray,
      addNewItem,
      removeFromArray,
      updateSubmitState,
      formState,
      setFormValues,
      OpenReArrangeFunction,
      MasterAddEditAccess,
      MasterDeleteAccess,
    ],
  );

  return (
    <Context.Provider value={value}>
      <CostingStageMaster />
    </Context.Provider>
  );
}

export default ContextWrapper;
